export default {
  computed: {
    paletteFidmarques () {
      return {
        orange: '#FF9113',
        yellow: '#FFBC00',
        fuchsia: '#FF5A5C',
        blue: '#3498DB',
        black: '#4A4A4A',
        red: '#FF114A',
        green: '#42C977',
        violet: '#9B59B6',
        pink: '#ED70A3',

        v2: {
          blue: '#3498DB',
          green: '#2ECC71',
          yellow: '#F1C40F',
          violet: '#9B59B6',
        },

        orangeLight: '#FFAE14',
      }
    },
    styleColorOrange () {
      return { color: this.paletteFidmarques.orange }
    },
    styleColorfuchsia () {
      return { color: this.paletteFidmarques.fuchsia }
    },
    styleBackgroundColorYellow () {
      return { backgroundColor: this.paletteFidmarques.yellow }
    },
    styleBackgroundColorfuchsia () {
      return { backgroundColor: this.paletteFidmarques.fuchsia }
    },
  },
}
